import { render, staticRenderFns } from "./SettingInstrData.vue?vue&type=template&id=6132fa24"
import script from "./SettingInstrData.vue?vue&type=script&lang=ts"
export * from "./SettingInstrData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports